<script>
import { mapState, mapActions } from 'vuex';
import TransportationTableInputs from '../../components/transportation/TransportationTableInputs';
import TransportationRouteCheckInInformation from
  '../../components/transportation/TransportationRouteCheckInInformation';
import TransportationRoutesMapping from '../../components/transportation/TransportationRoutesMapping';
import TransportationRoutesEdit from '../../components/transportation/TransportationRoutesEdit';
import ConfirmDialog from '../../components/TwConfirmDialog';
import TransportationRouteTextsInformation from '../../components/transportation/TransportationRouteTextsInformation';

export default {
  name: 'TransportationRoutes',
  components: {
    TransportationTableInputs,
    TransportationRouteCheckInInformation,
    TransportationRoutesMapping,
    TransportationRoutesEdit,
    TransportationRouteTextsInformation,
    ConfirmDialog,
  },
  computed: {
    ...mapState({
      statePagination: state => state.transportation.routes.pagination,
      routes: state => state.transportation.routes.items,
      route: state => state.transportation.routes.route,
      search: state => state.transportation.routes.search,
      itemsError: state => state.transportation.routes.itemsError,
      itemsLoading: state => state.transportation.routes.itemsLoading,
      lastSupplier: state => state.transportation.routes.supplier,
      supplier: state => state.transportation.suppliers.supplier,
      suppliers: state => state.transportation.suppliers.items,
    }),
  },
  methods: {
    ...mapActions({
      searchRoutes: 'transportation/routesSearch',
      setActiveRoute: 'transportation/routesSetActive',
      loadRoutesAction: 'transportation/routesLoad',
      updatePagination: 'transportation/routesUpdatePagination',
      clearRouteTextsList: 'transportation/clearRouteTextsList',
    }),
    changePage(page) {
      this.pagination.page = page;
    },
    loadRoutes(force = false) {
      if (force || this.supplier !== this.lastSupplier) {
        this.loadRoutesAction()
          .then(() => {
            this.pagination.totalItems = this.routes.length;
          });
      }
    },
    openEditRoute(route) {
      if (!this.route || this.route.id !== route.id) {
        this.setActiveRoute(route);
      }
      this.editRouteShow = true;
    },
    openEditRouteMapping(route) {
      this.setActiveRoute(route);
      this.editMappingShow = true;
    },
    closeEditConfirm(force = false) {
      if (this.dialogChangesMade && !force) {
        this.$refs.confirm.open();
      } else {
        this.confirmCloseEditDialog();
      }
    },
    confirmCloseEditDialog() {
      if (this.editMappingShow) {
        this.editMappingShow = false;
      } else if (this.editRouteShow) {
        this.editRouteShow = false;
      } else if (this.editRouteCheckInInformationShow) {
        this.editRouteCheckInInformationShow = false;
      } else if (this.editRouteTextsInformationShow) {
        this.editRouteTextsInformationShow = false;
        this.clearRouteTextsList();
      }
    },
    openRouteCheckInInformation(route) {
      this.setActiveRoute(route);
      this.editRouteCheckInInformationShow = true;
    },
    closeRouteCheckInInformationShow(force = false) {
      if (this.dialogChangesMade && !force) {
        this.$refs.confirm.open();
      } else {
        this.confirmCloseEditDialog();
      }
    },
    openRouteTextsInformation(route) {
      this.setActiveRoute(route);
      this.editRouteTextsInformationShow = true;
    },

  },
  data() {
    return {
      headers: [
        { text: this.$t('transportation.routes.table.type'), class: 'px-1', value: 'Type' },
        { text: this.$t('transportation.routes.table.origin'), class: 'px-2', value: 'originName' },
        { text: this.$t('transportation.routes.table.originWebName'), class: 'px-2', value: 'originWebName' },
        { text: this.$t('transportation.routes.table.originExternalRef'), class: 'px-2', value: 'originExternalRef' },
        { text: this.$t('transportation.routes.table.destination'), class: 'px-2', value: 'destinationName' },
        { text: this.$t('transportation.routes.table.destinationWebName'), class: 'px-2', value: 'destinationWebName' },
        {
          text: this.$t('transportation.routes.table.destinationExternalRef'),
          class: 'px-2',
          value: 'destinationExternalRef',
        },
        { text: this.$t('transportation.routes.table.areas'), width: '70px', class: 'px-2', value: 'areaIds' },
        { text: this.$t('transportation.routes.table.active'), width: '70px', class: 'px-2', value: 'active' },
        {
          text: this.$t('transportation.routes.table.actions'),
          width: '145px',
          sortable: false,
          class: 'px-2',
          value: '',
        },
      ],
      pagination: {},
      editRouteShow: false,
      editMappingShow: false,
      editRouteCheckInInformationShow: false,
      editRouteTextsInformationShow: false,
      dialogChangesMade: false,
      country: undefined,
      selectedAreas: [],
      confirm: {
        title: this.$t('dialog.cancel.title'),
        description: this.$t('dialog.cancel.text'),
      },
    };
  },
  created() {
    this.pagination = Object.assign(this.pagination, this.statePagination);
    this.loadRoutes();
  },
  beforeDestroy() {
    this.updatePagination(Object.assign({}, this.pagination));
  },
};
</script>

<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs6>
        <transportation-table-inputs
          @change="loadRoutes"
          @search="searchRoutes"
          :disabled="itemsLoading"
          :search="search"
        />
      </v-flex>
    </v-layout>

    <v-layout mt-3 row>
      <v-flex>
        <v-data-table
          class="print"
          :items="routes"
          :headers="headers"
          :loading="itemsLoading"
          :pagination.sync="pagination"
          :search="search"
          :no-results-text="$t('transportation.routes.noResults')"
          hide-actions
          must-sort>
          <template slot="items" slot-scope="props">
            <tr :class="{ 'blue lighten-5': route && props.item.id === route.id }">
              <td class="px-1">
                <v-icon v-if="props.item.type === 'ferry'" title="ferry">directions_boat</v-icon>
                <v-icon v-else-if="props.item.type === 'train'" title="train">train</v-icon>
                <v-icon v-else title="flight">flight</v-icon>
              </td>
              <td class="px-2">{{ props.item.origin }}</td>
              <td class="px-2">{{ props.item.originWebName }}</td>
              <td class="px-2">{{ props.item.originExternalRef }}</td>
              <td class="px-2">{{ props.item.destination }}</td>
              <td class="px-2">{{ props.item.destinationWebName }}</td>
              <td class="px-2">{{ props.item.destinationExternalRef }}</td>
              <td class="px-2">{{ props.item.areaIds.length }}</td>
              <td class="px-2">
                <v-icon v-if="props.item.active" color="green">
                  done
                </v-icon>
                <v-icon v-else color="red">
                  close
                </v-icon>
              </td>
              <td class="px-1 pr-1">
                <v-icon
                  @click="openRouteTextsInformation(props.item)"
                  color="grey darken-2"
                  title="Add/remove helper texts"
                >
                  tag
                </v-icon>

                <v-icon
                  @click="openRouteCheckInInformation(props.item)"
                  color="grey darken-2"
                  :title="$t('transportation.routes.actions.hints.addCheckInInformation')"
                >
                  info
                </v-icon>
                <v-icon
                  @click="openEditRouteMapping(props.item)"
                  color="purple darken-2"
                  :title="$t('transportation.routes.actions.hints.addRemoveAreasOnRoute')"
                >
                  map
                </v-icon>
                <v-icon
                  @click="openEditRoute(props.item)"
                  class="ferry-edit"
                  color="teal darken-2"
                  :title="$t('transportation.routes.actions.hints.editRoute')"
                >
                  edit
                </v-icon>
              </td>
            </tr>
          </template>
          <template slot="no-data">
            <div v-if="itemsError">
              <v-alert :value="true" icon="warning">
                {{ $t('transportation.routes.actions.load.error') }}.
                <span class="refresh-text" @click="loadRoutes(true)">
                  {{ $t('inputs.misc.tryAgain') }}
                </span>
              </v-alert>
            </div>
            <div class="text-xs-center" v-else-if="!supplier">
              <span>{{ $t('transportation.suppliers.choose') }}</span>
            </div>
            <div class="text-xs-center" v-else-if="!itemsLoading">
              <span>{{ $t('transportation.routes.noData') }}</span>
            </div>
            <div class="text-xs-center" v-else>
              <!--Show nothing when loading-->
            </div>
          </template>
        </v-data-table>
      </v-flex>

      <v-dialog
        v-model="editRouteTextsInformationShow"
        @keydown.esc="confirmCloseEditDialog"
        max-width="1200px"
        no-click-animation
        persistent>
        <transportation-route-texts-information
          @close="confirmCloseEditDialog"
          :shown="editRouteTextsInformationShow"
        />
      </v-dialog>


      <v-dialog
        v-model="editRouteCheckInInformationShow"
        @keydown.esc="closeRouteCheckInInformationShow"
        max-width="1200px"
        no-click-animation
        persistent>
        <transportation-route-check-in-information
           v-model="dialogChangesMade"
           @close="closeRouteCheckInInformationShow"
           :shown="editRouteCheckInInformationShow"
        />
      </v-dialog>

      <v-dialog
        v-model="editMappingShow"
        @keydown.esc="closeEditConfirm"
        max-width="1200px"
        no-click-animation
        persistent>
        <transportation-routes-mapping
          v-model="dialogChangesMade"
          @close="closeEditConfirm"
          :shown="editMappingShow"
        />
      </v-dialog>

      <v-dialog
        v-model="editRouteShow"
        @keydown.esc="closeEditConfirm"
        max-width="600px"
        no-click-animation
        persistent>
        <transportation-routes-edit
          v-model="dialogChangesMade"
          @close="closeEditConfirm"
          :shown="editRouteShow"
        />
      </v-dialog>

      <confirm-dialog
        @confirm="confirmCloseEditDialog"
        :title="confirm.title"
        :description="confirm.description"
        ref="confirm">
      </confirm-dialog>
    </v-layout>

    <v-layout justify-center mt-3 row v-if="routes">
      <v-flex shrink>
        <v-pagination
          @input="changePage"
          :value="pagination.page"
          :length="Math.ceil(pagination.totalItems / pagination.rowsPerPage)"
          total-visible="10">
        </v-pagination>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style type="scss">
  .refresh-text {
    text-decoration: underline;
    cursor: pointer;
  }

  .ferry-edit {
    margin-bottom: 1px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/transportation/TransportationRoutes.vue